export const trackEvent = (eventName, eventParams = {}) => {
    if (typeof window !== 'undefined' && window.gtag) {
        window.gtag('event', eventName, eventParams);

        // console.log(`[Analytics] Event tracked: ${eventName}`, eventParams);
    } else {
        // console.warn('[Analytics] gtag not available');
    }
};

export const trackSectionView = (sectionName) => {
    trackEvent('section_view', {
        section_name: sectionName,
        module: 'navigation'
    });
};

export const trackProfileUpdate = (success) => {
    trackEvent('profile_update', {
        status: success ? 'success' : 'failure',
        module: 'account'
    });
};

export const trackChallengeAction = (gameName, challengeId, action) => {
    trackEvent('challenge_engagement', {
        challenge_game_name: gameName,
        action: action,
        game_name: gameName,
        module: 'challenge'
    });
};

export const trackDailyCheckin = (day, credits) => {
    trackEvent('daily_checkin', {
        module: 'engagement'
    });
};

export const trackGameSelection = (gameName, gameId) => {
    trackEvent('dailytask_game_selected', {
        dailytask_game_name: gameName,
        game_name: gameName,
        module: 'daily_task'
    });
};

export const trackTournamentSignup = (tournamentName, tournamentId, tournamentType, gameName = '') => {
    trackEvent('tournament_signup', {
        tournament_name: tournamentName,
        tournament_type: tournamentType,
        tournament_game_name: gameName,
        game_name: gameName,
        module: 'tournament'
    });
};


export const trackRewardRedemptionAttempt = (rewardName, rewardId, credits) => {
    trackEvent('reward_redemption_attempt', {
        reward_attempted_name: rewardName,
        reward_name: rewardName,
        module: 'redemption_attempt'
    });
};

export const trackRewardRedemptionSuccess = (rewardName, itemId, credits) => {
    trackEvent('reward_redemption_success', {
        reward_redeemed_name: rewardName,
        reward_name: rewardName,
        module: 'redemption_success'
    });
};

export const trackGameStart = (gameName, gameMode = 'single_player') => {
    trackEvent('game_start', {
        esl_game_name: gameName,
        game_mode: gameMode,
        game_name: gameName,
        module: 'gaming'
    });
};

export const trackGameEnd = (gameName, timeSpent, gameMode = 'single_player', completed = false) => {
    trackEvent('game_end', {
        esl_game_name: gameName,
        game_mode: gameMode,
        completed: completed,
        game_name: gameName,
        module: 'gaming'
    });
};

export const trackPageView = (pageName, pagePath) => {
    trackEvent('page_view', {
        page_name: pageName,
        page_path: pagePath,
        module: 'navigation'
    });
};

export const trackUserEngagement = (action, label = '') => {
    trackEvent('user_engagement', {
        event_category: 'engagement',
        event_label: label,
        engagement_action: action
    });
};

export const trackUnsubscribe = (status, msisdn = '') => {
    trackEvent('unsubscribe', {
        status: status,
        module: 'account'
    });
};

export const initGameTimeTracking = () => {
    const startTime = Date.now();

    return {
        startTime,
        getElapsedTime: () => Math.floor((Date.now() - startTime) / 1000)
    };
};
